import { render, staticRenderFns } from "./search-suggestions.vue?vue&type=template&id=6c6ac5d4"
import script from "./search-suggestions.vue?vue&type=script&lang=js"
export * from "./search-suggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseImage: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/09062026_084924/resources/assets/marketplace/components/BaseImage.vue').default})
